import React from 'react';
import PropTypes from 'prop-types';
import { Container, Row, Col, Collapse } from 'reactstrap';
import Input from '../FormElement/Input';
import Boolean from '../FormElement/Boolean';
import Display from '../FormElement/Display';
import Select from '../FormElement/Select';
import SelectMultiple from '../FormElement/SelectMultiple';
import ConditionalSelect from '../FormElement/ConditionalSelect';
import RimSize from '../FormElement/RimSize';
import Image from '../FormElement/Image';
import CarProfileContainer from '../CarProfile/CarProfileContainer';
import Translate from '../common/Translate';
import useConditionalDisplay from '../../services/Form/useConditionalDisplay';
import MultipleDamage from '../FormElement/MultipleDamage';
import useValue from '../../services/Form/useValue';
import AlertElement from '../FormElement/AlertElement';
import MultiplePhoto from '../FormElement/MultiplePhoto';
import MultipleAnomaly from '../FormElement/MultipleAnomaly';

const QuestionBlock = (props) => {
  const { question, formId, sectionId, country } = props;
  const elementIds = { formId, sectionId, questionId: question.id };
  const [display] = useConditionalDisplay(question.remove_if, elementIds, question);
  const [hide] = useValue(formId, sectionId, question.id, question.type, 'hide');
  let questionLabel = question.id;

  if (country === 'UK') {
    switch (question.id) {
      case 'last_servicing_km':
        questionLabel = 'last_servicing_miles';
        break;
      case 'vehicule_test_mileage':
        questionLabel = 'vehicule_test_mileage_in_miles';
        break;
      case 'client_zip':
        question.type = 'string';
        break;
      default:
        questionLabel = question.id;
    }
  }
  const renderElement = () => {
    let element;

    switch (question.type) {
      default:
        element = (
          <>
            <Input question={question} elementIds={elementIds} />
            ??? {question.type} ???
          </>
        );
        break;
      case 'text':
      case 'string':
      case 'integer':
      case 'number':
      case 'date':
      case 'month':
      case 'km':
      case 'textarea':
      case 'dropdowns':
        element = <Input question={question} elementIds={elementIds} />;
        break;

      case 'display':
        element = <Display elementIds={elementIds} />;
        break;

      case 'boolean':
        element = <Boolean question={question} elementIds={elementIds} />;
        break;

      case 'select_multiple':
        element = <SelectMultiple question={question} elementIds={elementIds} />;
        break;

      case 'select':
        element = <Select question={question} elementIds={elementIds} />;
        break;

      case 'image':
        element = <Image question={question} elementIds={elementIds} />;
        break;

      case 'conditional_select':
        element = <ConditionalSelect question={question} elementIds={elementIds} />;
        break;

      case 'rim_size':
        element = <RimSize question={question} elementIds={elementIds} />;
        break;

      case 'zone_select':
        element = <CarProfileContainer {...props} question={question} elementIds={elementIds} />;
        break;

      case 'multiple_anomaly':
        element = <MultipleAnomaly question={question} elementIds={elementIds} />;
        break;

      case 'multiple_damages':
        element = <MultipleDamage question={question} elementIds={elementIds} />;
        break;

      case 'select_alerts':
        element = <AlertElement question={question} elementIds={elementIds} />;
        break;

      case 'multiple_photos':
        element = <MultiplePhoto question={question} elementIds={elementIds} />;
        break;
    }
    return element;
  };

  return (
    <Container>
      <Collapse isOpen={display && !hide}>
        <Row>
          <Col xs="12">
            <div className="form-group mb-5">
              <label className="d-block text-left text-primary h5" htmlFor={questionLabel}>
                <Translate code={questionLabel} />
                {question.required ? '*' : ''}
              </label>
              {renderElement()}
            </div>
          </Col>
        </Row>
      </Collapse>
    </Container>
  );
};

export default QuestionBlock;

QuestionBlock.propTypes = {
  question: PropTypes.shape().isRequired,
  formId: PropTypes.string.isRequired,
  sectionId: PropTypes.string.isRequired,
  country: PropTypes.string.isRequired,
};
